import { render } from "./BottomMenu.html?vue&type=template&id=e93f99fe&scoped=true&ts=true&external"
import script from "./BottomMenu.ts?vue&type=script&lang=ts&external"
export * from "./BottomMenu.ts?vue&type=script&lang=ts&external"

import "./BottomMenu.scss?vue&type=style&index=0&id=e93f99fe&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e93f99fe"]])

export default __exports__